<template>
  <div
    class="question-container"
    :style="{
      border:
        dataObj.status === 1
          ? '1px dashed rgba(58,96,255,1)'
          : '1px solid #dcdde0',
    }"
  >
    <div class="question-type">填空</div>
    <div class="title-view">
      <div style="color: #4c4a56">
        <div style="color: #4c4a56">
          <div v-html="richNodes" class="case-problem-html"></div>
        </div>
      </div>
    </div>
    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 20px; position: relative"
      >
        <img :src="item" style="width: 100%" />
      </div>
    </div>
    <div v-for="(item, idx) in answerList" :key="idx" class="input-item">
      <div class="input-index">{{ idx + 1 }}</div>
      <div v-if="showState === 10 || showState === 7">
        <div
          v-if="item.color === '1'"
          class="choose-css"
          style="
            border: 1px solid rgba(74, 115, 247, 0.5);
            background: rgba(74, 115, 247, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(58, 96, 255, 1);
            "
          >
            {{ item.context }}
          </span>
          <div style="display: flex; align-items: center">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747725751245.svg"
              style="width: 30px; height: 30px"
            />
          </div>
        </div>
        <div
          v-if="item.color === '2'"
          class="choose-css"
          style="
            border: 1px solid rgba(247, 59, 66, 0.5);
            background: rgba(247, 59, 66, 0.1);
          "
        >
          <span
            style="
              white-space: normal;
              word-break: break-all;
              color: rgba(247, 59, 66, 1);
            "
          >
            {{ item.context }}
          </span>
          <div style="display: flex; align-items: center">
            <img
              src="https://ossfastmake.mustke.com/qrCode/tupian/1747885842739.svg"
              style="width: 30px; height: 30px"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        :style="{
          border:
            isFocus === idx
              ? `1px solid rgba(${themeColor.r},${themeColor.g},${themeColor.b})`
              : '1px solid #EDEDED',
        }"
        class="textarea-view"
      >
        <el-input
          v-if="dataObj.status === 3 || dataObj.status === 4"
          type="textarea"
          v-model="item.context"
          placeholder="请输入"
          :autosize="{ minRows: 1 }"
          @focus="handleInputFocus(idx)"
          @blur="handleInputBlur()"
          @input="handleInputChange(idx)"
          :disabled="
            dataObj.status !== 4 || showState === 10 || showState === 7
          "
        ></el-input>
        <span v-else class="textarea-placeholder">请输入</span>
      </div>
    </div>
    <div v-if="showState === 10 || showState === 7">
      <div
        v-if="dataObj.ifRight"
        style="display: flex; align-items: center; margin-top: 20px"
      >
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335507420.svg"
          style="width: 32px; height: 32px"
        />
        <span class="correct-text">回答正确 +{{ dataObj.score }}分</span>
      </div>
      <div v-else style="display: flex; align-items: center; margin-top: 20px">
        <img
          src="https://ossfastmake.mustke.com/qrCode/tupian/1748335577224.svg"
          style="width: 32px; height: 32px"
        />
        <span class="error-text" style="font-size: 30px; font-weight: 500"
          >答错了 {{ dataObj.score > 0 ? `+${dataObj.score}分` : "" }}</span
        >
      </div>
      <div v-if="!dataObj.ifRight" style="margin-top: 20px">
        <span
          style="
            font-size: 30px;
            font-weight: 500;
            text-align: left;
            color: #00c755;
          "
          >正确答案</span
        >
        <div
          style="
            width: 100%;
            padding: 25px;
            box-sizing: border-box;
            background: #f7f7f7;
            border: 1px solid #ededed;
            border-radius: 6px;
            margin-top: 15px;
          "
        >
          {{ dataObj.chooseAnswer }}
        </div>
      </div>
      <div class="explanation-section" style="margin-top: 20px">
        <span class="section-title" style="font-size: 30px; font-weight: 500"
          >答案解析</span
        >
        <div class="textarea-view">{{ dataObj.analysis || "暂无内容" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamPreviewSBQ",
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      answerList: [],
      isFocus: -1,
      images: [],
      index: 0,
      themeColor: {
        r: 58,
        g: 96,
        b: 255,
      },
      showState: 0,
    };
  },
  computed: {
    richNodes() {
      if (!this.dataObj.caseProblem) return "";

      let count = 0;
      let prefix =
        this.dataObj.isMust === 1
          ? `<span style="color:#F73B42;">*</span>${this.index + 1}、`
          : `${this.index + 1}、`;

      const body = this.dataObj.caseProblem.replace(/____/g, () => {
        const html = `
          <span style="border-bottom: 1px solid #494949; padding-bottom: 3px; position: relative; top: -3px;">
            <b style="font-weight: normal; font-size: 10px; color: #494949; text-align: center; display: inline-flex; align-items: center; justify-content: center; border: 1px solid #494949; width: 15px; height: 15px; border-radius: 25px; margin-left: 10px; margin-right: 8px;">
              ${count + 1}
            </b>
          </span>
        `;
        count++;
        return html;
      });

      return (
        prefix +
        body +
        `<span style="position:relative;top:-1px;padding:0 8px;line-height:24px;background:rgba(58,96,255,0.09);border:1px solid rgba(58,96,255,0.4);border-radius:4px;font-size:13px;font-weight:500;text-align:center;color:#3a60ff;display:inline-block;margin-left:5px">${this.dataObj.questionScore}分</span>`
      );
    },
  },
  watch: {
    params: {
      handler(newValue) {
        if (newValue && newValue.data) {
          this.dataObj = newValue.data;
          this.index = newValue.index;
          this.images = JSON.parse(newValue.data.caseProblemImg || "[]");
          this.showState = newValue.state;

          if (newValue.data.answer) {
            this.answerList = newValue.data.answer.map((item) => ({
              id: item.id,
              context: item.context,
              color: item.color,
            }));
          } else {
            const num = newValue.data.caseProblem.split("____").length - 1;
            let answer = [];
            for (let j = 0; j < num; j++) {
              answer.push({ id: "", context: "" });
            }
            this.answerList = answer;
          }

          if (newValue.theme !== null) {
            this.themeColor = {
              r: newValue.theme.themeColor.r,
              g: newValue.theme.themeColor.g,
              b: newValue.theme.themeColor.b,
            };
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleInputFocus(index) {
      this.isFocus = index;
    },
    handleInputBlur() {
      this.isFocus = -1;
    },
    handleInputChange(index) {
      const updatedData = {
        ...this.dataObj.data,
        answer: this.answerList.map((item) => ({
          id: item.id,
          context: item.context,
        })),
      };

      this.$emit(
        "update",
        JSON.stringify({
          data: updatedData,
          answer: {
            question_id: this.dataObj.data.id,
            type: this.dataObj.data.type,
            if_hide: this.dataObj.data.if_hide,
            answer: this.answerList,
          },
          index: this.index,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./exam-preview-common.scss";

.title-view > div {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.title-view > div > div {
  display: flex;
  align-items: flex-end;
}

.case-problem-html {
  flex: 1;
}

.input-item {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px;

  .input-index {
    width: 25px;
    height: 25px;
    border: 1px solid #494949;
    border-radius: 20px;
    font-size: 14px;
    color: #494949;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
  }
}

.textarea-view {
  min-height: 40px;
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/ExamPreview/ExamPreviewSBQ.vue